import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './AddressAutocomplete.css';

export const AddressAutocomplete = ({ onAddressSelect, initialValue = '' }) => {
  const { i18n } = useTranslation();
  const isGerman = i18n.language === 'de';
  const inputRef = useRef(null);
  const autocompleteRef = useRef(null);
  const [inputValue, setInputValue] = useState(initialValue);

  useEffect(() => {
    if (!window.google || !inputRef.current) return;

    // Initialize Google Places Autocomplete - Worldwide
    autocompleteRef.current = new window.google.maps.places.Autocomplete(inputRef.current, {
      types: ['address'],
      // No country restrictions - worldwide search
    });

    // Listen for place selection
    autocompleteRef.current.addListener('place_changed', () => {
      const place = autocompleteRef.current.getPlace();

      if (!place.geometry) {
        console.log('No details available for input: ' + place.name);
        return;
      }

      // Extract address components
      const addressComponents = place.address_components;
      const address = {
        street: '',
        house_no: '',
        zip: '',
        city: '',
        country: '',
        formatted: place.formatted_address,
        place_id: place.place_id,
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };

      // Parse address components
      addressComponents.forEach((component) => {
        const types = component.types;

        if (types.includes('route')) {
          address.street = component.long_name;
        }
        if (types.includes('street_number')) {
          address.house_no = component.long_name;
        }
        if (types.includes('postal_code')) {
          address.zip = component.long_name;
        }
        if (types.includes('locality')) {
          address.city = component.long_name;
        }
        if (types.includes('country')) {
          address.country = component.long_name;
        }
      });

      // Update input value
      setInputValue(place.formatted_address);

      // Call parent callback
      onAddressSelect(address);
    });

    return () => {
      if (autocompleteRef.current) {
        window.google.maps.event.clearInstanceListeners(autocompleteRef.current);
      }
    };
  }, [onAddressSelect]);

  return (
    <div className="address-autocomplete">
      <label htmlFor="address-input" className="address-label">
        {isGerman ? 'Vollständige Adresse' : 'Complete Address'} *
      </label>
      <input
        ref={inputRef}
        id="address-input"
        type="text"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        placeholder={isGerman 
          ? 'Beginnen Sie mit der Eingabe Ihrer Adresse...' 
          : 'Start typing your address...'}
        className="address-input"
        data-testid="address-autocomplete-input"
      />
      <p className="address-hint">
        {isGerman
          ? '💡 Wählen Sie eine Adresse aus den Vorschlägen aus'
          : '💡 Select an address from the suggestions'}
      </p>
    </div>
  );
};
